import { HttpError } from 'modules/http-client'
import { Action } from 'modules/store'

import { SuggestActionPayload } from './types'

export const GET_SUGGEST_DATA = '[suggest] Get data'
export const GET_SUGGEST_DATA_SUCCESS = '[suggest] Get data success'
export const GET_SUGGEST_DATA_FAILURE = '[suggest] Get data failure'

export const GET_SUGGEST_ONE = '[suggest] Get one'
export const GET_SUGGEST_ONE_SUCCESS = '[suggest] Get one success'
export const GET_SUGGEST_ONE_FAILURE = '[suggest] Get one failure'

export const CLEAN_SUGGEST_DATA = '[suggest] Clean'

export class GetSuggestDataAction implements Action {
  readonly type = GET_SUGGEST_DATA
  constructor(public payload: SuggestActionPayload) {}
}

export class GetSuggestDataSuccessAction implements Action {
  readonly type = GET_SUGGEST_DATA_SUCCESS
  constructor(public payload: { storeId: string; data: any[] }) {}
}

export class GetSuggestDataFailureAction implements Action {
  readonly type = GET_SUGGEST_DATA_FAILURE
  constructor(public payload: HttpError) {}
}

export class CleanSuggestDataAction implements Action {
  readonly type = CLEAN_SUGGEST_DATA
  constructor(public payload: string) {}
}

export type SuggestActions =
  | GetSuggestDataAction
  | GetSuggestDataSuccessAction
  | GetSuggestDataFailureAction
  | CleanSuggestDataAction

export default SuggestActions



// WEBPACK FOOTER //
// ./src/modules/forms/suggest-adapter/suggest-adapter.actions.ts